import { initSlider, visibilityItem, removeLoading } from './slider-util';

export const initCategoryBanner = () => {
    const selector = '.category-banner';
    const sliderConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000
    };

    visibilityItem(selector);
    window.require(['slick'], () => {
        initSlider(selector, sliderConfig);
        removeLoading(selector);
    });
};
